if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // Apply quantity-based promotional rules
            this.applyPromotionalRules().then(() => {
              this.processCartUpdate(response);
            }).catch((error) => {
              console.error('Error applying promotional rules:', error);
              // Continue with normal cart update even if promo fails
              this.processCartUpdate(response);
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      processCartUpdate(response) {
        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: this.variantIdInput.value,
            cartData: response,
          });
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      }

      async applyPromotionalRules() {
        try {
          // Get current cart contents
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          // Define promotional products
          const MAIN_PRODUCT = '46480730095883';
          const PROMO_PRODUCT_1 = '52443362361611'; // For 2-5 units
          const PROMO_PRODUCT_2 = '52443356233995'; // For 6+ units
          
          // Count main product quantity
          let mainProductQty = 0;
          let promoProduct1Qty = 0;
          let promoProduct2Qty = 0;
          
          cart.items.forEach(item => {
            if (item.variant_id.toString() === MAIN_PRODUCT) {
              mainProductQty += item.quantity;
            } else if (item.variant_id.toString() === PROMO_PRODUCT_1) {
              promoProduct1Qty += item.quantity;
            } else if (item.variant_id.toString() === PROMO_PRODUCT_2) {
              promoProduct2Qty += item.quantity;
            }
          });
          
          // Calculate required promo products based on rules
          let requiredPromo1 = 0;
          let requiredPromo2 = 0;
          
          if (mainProductQty >= 2 && mainProductQty <= 3) {
            requiredPromo1 = 1;
          } else if (mainProductQty >= 4 && mainProductQty <= 5) {
            requiredPromo1 = 3;
          } else if (mainProductQty >= 6) {
            requiredPromo2 = 1;
          }
          
          // Adjust promo product quantities
          const updates = [];
          
          // Handle promo product 1 (52443362361611)
          if (requiredPromo1 !== promoProduct1Qty) {
            if (requiredPromo1 === 0 && promoProduct1Qty > 0) {
              // Remove all promo product 1
              updates.push(this.updateCartItem(PROMO_PRODUCT_1, 0));
            } else if (requiredPromo1 > promoProduct1Qty) {
              // Add the difference
              const difference = requiredPromo1 - promoProduct1Qty;
              updates.push(this.addCartItem(PROMO_PRODUCT_1, difference));
            } else if (requiredPromo1 < promoProduct1Qty) {
              // Remove excess by setting to exact required amount
              updates.push(this.setCartItemQuantity(PROMO_PRODUCT_1, requiredPromo1));
            }
          }
          
          // Handle promo product 2 (52443356233995)
          if (requiredPromo2 !== promoProduct2Qty) {
            if (requiredPromo2 === 0 && promoProduct2Qty > 0) {
              // Remove all promo product 2
              updates.push(this.updateCartItem(PROMO_PRODUCT_2, 0));
            } else if (requiredPromo2 > promoProduct2Qty) {
              // Add the difference
              const difference = requiredPromo2 - promoProduct2Qty;
              updates.push(this.addCartItem(PROMO_PRODUCT_2, difference));
            } else if (requiredPromo2 < promoProduct2Qty) {
              // Remove excess by setting to exact required amount
              updates.push(this.setCartItemQuantity(PROMO_PRODUCT_2, requiredPromo2));
            }
          }
          
          // Execute all updates sequentially to avoid conflicts
          for (const update of updates) {
            await update;
          }
          
        } catch (error) {
          console.error('Error in promotional rules:', error);
          throw error;
        }
      }

      async updateCartItem(variantId, quantity) {
        try {
          // Remove item from cart by setting quantity to 0
          const updates = {};
          updates[variantId] = quantity;
          
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ updates })
          });
        } catch (error) {
          console.error('Error updating cart item:', error);
          throw error;
        }
      }

      async addCartItem(variantId, quantity) {
        try {
          // Add specific quantity to cart
          return fetch(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: quantity
              }]
            })
          });
        } catch (error) {
          console.error('Error adding cart item:', error);
          throw error;
        }
      }

      async setCartItemQuantity(variantId, quantity) {
        try {
          // Set exact quantity using cart update
          const updates = {};
          updates[variantId] = quantity;
          
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ updates })
          });
        } catch (error) {
          console.error('Error setting cart item quantity:', error);
          throw error;
        }
      }
    }
  );
}
